import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ZtDropdownConfig, ZtDropdownOption } from './zt-dropdown.model';

@Component({
    selector: 'zt-dropdown',
    templateUrl: 'zt-dropdown.component.html',
    styleUrls: ['zt-dropdown.component.scss'],
})
export class ZtDropdownComponent {
    @Input() config: ZtDropdownConfig | undefined;
    @Input() options: ZtDropdownOption[] = [];
    @Input() control!: FormControl;

    @Output() onChange = new EventEmitter<ZtDropdownOption>();

    onChangeListener(selectedOption: ZtDropdownOption) {
        this.onChange.emit(selectedOption);
    }
}
